'use client';

import ActionButton from '@/components/form/ActionButton/ActionButton';
import { useGlobalLoadingAtom } from '@/state';
import { sendClickGuestPurchaseEvent } from '@/utils/ga';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { useLogin } from '../../hooks/useLogin';
import LoginForm from '../LoginForm/LoginForm';
import styles from './PurchaseAuthSelector.module.scss';

/**
 * 購入フロー専用の認証選択画面
 * 初期: 3ボタン表示（ログインして購入する / 新規会員登録して購入する / 登録せずにゲスト購入する）
 * 「ログインして購入する」クリック: LoginForm をインライン展開
 */
function PurchaseAuthSelector({
  callbackUrl,
}: {
  callbackUrl: string;
}) {
  const router = useRouter();
  const [isLoginExpanded, setIsLoginExpanded] = useState(false);
  const [, startGlobalLoading] = useGlobalLoadingAtom();
  const { login, isLoading } = useLogin(callbackUrl);

  const handleSignupClick = () => {
    startGlobalLoading();
    router.push(`/auth/signup?callbackUrl=${encodeURIComponent(callbackUrl)}`);
  };

  const handleGuestPurchaseClick = () => {
    startGlobalLoading();
    // GAイベント送信
    sendClickGuestPurchaseEvent();
    router.push('/guest/purchase');
  };

  return (
    <div className={styles.container}>
      <p className={styles.description}>ご注文手続きに進みます。</p>

      {isLoginExpanded ? (
        <div className={styles.loginSection}>
          <LoginForm onSubmit={login} isLoading={isLoading} />
        </div>
      ) : (
        <div className={styles.buttonSection}>
          <ActionButton bgColor='primary' color='white' onClick={() => setIsLoginExpanded(true)}>
            ログインして購入する
          </ActionButton>
        </div>
      )}

      <div className={styles.signupSection}>
        <div className={styles.buttonSection}>
          <ActionButton color='primary' bgColor='white' outlined borderColor='gray300' onClick={handleSignupClick}>
            新規会員登録して購入する
          </ActionButton>
        </div>
        <p className={styles.signupNote}>
          ※すでに「Butterfly ID」をお持ちで新規登録する方は、上のボタンからログインください。
        </p>
      </div>

      <div className={styles.dividerSection}>
        <div className={styles.divider}>
          <span className={styles.dividerLine} aria-hidden='true' />
          <span className={styles.dividerText}>または</span>
          <span className={styles.dividerLine} aria-hidden='true' />
        </div>
        <div className={styles.buttonSection}>
          <ActionButton outlined borderColor='gray300' onClick={handleGuestPurchaseClick}>
            登録せずにゲスト購入する
          </ActionButton>
        </div>
      </div>
    </div>
  );
}

export default PurchaseAuthSelector;
